import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const courierPropList = async (params: object) => {
  return await GET({ url: Api.courierPropList, params, showError: false })
}
